// libs
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import {
  DisplaySettings,
  mapDisplayModeToConst,
  POST_DISPLAY_MODE_BANNER,
  POST_DISPLAY_MODE_COMPACT,
  POST_DISPLAY_MODE_DETAIL,
  POST_DISPLAY_MODE_PREVIEW,
  PostDisplayMode,
  Purpose
} from 'src/interfaces/posts'

// classes
import NavigationItem from 'src/components/navigation_item/navigation_item'

// styles
import './title.scss'

export const _classPrefix = `${CLASS_PREFIX}title__`

type TitleSettings = { show: boolean };

const _settings: DisplaySettings<TitleSettings> = {
  admin: {
    basic_ingredient: { show: true }
  },
  banner: {
    basic_ingredient: { show: true }
  },
  compact: {
    basic_ingredient: { show: true }
  },
  detail: {
    basic_ingredient: { show: true }
  },
  preview: {
    basic_ingredient: { show: true }
  }
}

export type IProps = {
  displayMode: PostDisplayMode;
  postDetailsURL?: string;
  purpose: Purpose;
  title?: string | null;
};

const Title: React.FC<IProps> = ({
  displayMode,
  postDetailsURL,
  purpose,
  title
}) => {
  const clsWithDisplayMode = `${_classPrefix}${mapDisplayModeToConst[displayMode]}`
  const settings = _settings[displayMode][purpose]

  const renderHeading = (className: string): JSX.Element => {
    switch (displayMode) {
      case POST_DISPLAY_MODE_DETAIL:
        return <h1 className={className}>{title}</h1>
      case POST_DISPLAY_MODE_PREVIEW:
        return <h2 className={className}>{title}</h2>
      case POST_DISPLAY_MODE_BANNER:
      case POST_DISPLAY_MODE_COMPACT:
        return <h3 className={className}>{title}</h3>
      default:
        return <h2 className={className}>{title}</h2>
    }
  }

  return settings?.show
    ? (
      <NavigationItem target="_self" url={postDetailsURL}>
        <div className={clsWithDisplayMode}>
          {/* this ellipsis-container is used by the RelatedContent component, see there */}
          <div className={`${clsWithDisplayMode}__ellipsis-container`}>
            {renderHeading(`${clsWithDisplayMode}__text`)}
          </div>
        </div>
      </NavigationItem>
    )
    : null
}

export default Title
